import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './arrow.scss';

export default function Arrow({ className, direction = 'down' }) {
	return (
		<svg
			className={classnames(className, direction, 'svg arrow')}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
		>
			<path
				fill="#2C9A00"
				d="M1 9.375c0 .339.13.678.388.937l5.3 5.3a1.324 1.324 0 0 0 1.874 0l5.3-5.3a1.324 1.324 0 0 0 0-1.874 1.324 1.324 0 0 0-1.874 0L8.95 11.476V1.425a1.325 1.325 0 1 0-2.65 0v10.051L3.262 8.438A1.324 1.324 0 0 0 1 9.375Z"
			/>
		</svg>
	);
}

Arrow.propTypes = {
	className: PropTypes.string,
	direction: PropTypes.string,
};
